import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useWatch } from "react-hook-form";

import { t } from "@/i18n-js/instance";

import type { SpaceFormValues } from "../../types";
import { shouldRenderNotificationField } from "../../utils/notificationVisibility";
import { NotificationField } from "../fields/NotificationField";
import { SectionShell } from "../SectionShell";

export const NotificationsSection = () => {
  const postType = useWatch<SpaceFormValues, "post_type">({
    name: "post_type",
  });
  const { currentCommunity } = usePunditUserContext();
  const isMobileNotificationsEnabled = Boolean(
    currentCommunity?.ios_app_enabled || currentCommunity?.has_branded_app,
  );

  const hasNotificationField = shouldRenderNotificationField({
    mobileNotificationsEnabled: isMobileNotificationsEnabled,
    postType,
  });

  if (!hasNotificationField) {
    return null;
  }

  return (
    <SectionShell
      title={t("spaces.form.create.sections.new_post_notifications")}
    >
      <NotificationField postType={postType} />
    </SectionShell>
  );
};
